import ContractFullDTO from "features/contracts/dtos/ContractFullDTO";
import ContractSimplifiedDTO from "features/contracts/dtos/ContractSimplifiedDTO";
import { TFunction } from "i18next";
import { formatDate } from "./Formatters";
import { formatISO, lastDayOfMonth } from "date-fns";

export const getTerminationDate = (contract: ContractFullDTO | ContractSimplifiedDTO, translate: TFunction): string => { 
  if (contract.contractDurationType === "IndefinitePeriod") {
    return translate("IndefinitePeriod")
  }
  
  if (contract.terminationDatePresentation) {
    return String(formatDate(contract.terminationDatePresentation));
  }
  
  return "-";
}

export const getDateStrByParts = (year: number, month: number, dayType: "first" | "last") => { 
  let date = new Date(year, month - 1, 1);

  if (dayType == "last") {
    date = lastDayOfMonth(date);
  }

  return formatISO(date, { representation: "date" });
}